import { render, staticRenderFns } from "./ZusatzbausteinTabelle.vue?vue&type=template&id=0e36766c&"
import script from "./ZusatzbausteinTabelle.vue?vue&type=script&lang=js&"
export * from "./ZusatzbausteinTabelle.vue?vue&type=script&lang=js&"
import style0 from "./ZusatzbausteinTabelle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow,VSpacer})
